export const FILE_INPUT_MAX_SIZE = 200 * 1024 * 1024; // 200MB

export const CSV_FILE_INPUT_MAX_SIZE = 1024 * 1024; // 1MB

export const FILE_INPUT_ACCEPTED_MIME_TYPES_AND_EXTENSIONS = Object.freeze({
    IMAGE: {
        'image/jpeg': ['.jpg', '.jpeg'],
        'image/png': ['.png'],
        'image/webp': ['.webp'],
    },
    AUDIO: {
        'audio/mpeg': ['.mp3'],
    },
    VIDEO: {
        'video/mp4': ['.mp4'],
    },
    JSON: {
        'application/json': ['.json'],
        'text/json': ['.json'],
    },
    CSV: {
        'text/csv': ['.csv'],
        'application/vnd.ms-excel': ['.csv'],
        'application/csv': ['.csv'],
    },
    PDF: {
        'application/pdf': ['.pdf'],
    },
    TXT: {
        'text/plain': ['.txt'],
    },
    ZIP: {
        'application/zip': ['.zip'],
        'application/x-zip-compressed': ['.zip'],
    },
    HTML: {
        'text/html': ['.html'],
        'application/xhtml+xml': ['.html'],
    },
    GIF: {
        'image/gif': ['.gif'],
    },
});

type Kind = 'pdf' | 'zip' | 'mp3' | 'json' | 'html' | 'csv' | 'txt' | 'jpeg' | 'png' | 'webp' | 'gif' | 'mp4';

// Hex signatures (uppercase, no 0x), with optional offset.
export const FILE_TYPES_SIGNATURE: Record<Kind, Array<{ hex: string; offset?: number }>> = {
    pdf: [{ hex: '25504446', offset: 0 }],
    zip: [
        { hex: '504B0304', offset: 0 },
        { hex: '504B0506', offset: 0 },
        { hex: '504B0708', offset: 0 },
    ],
    mp3: [{ hex: '494433', offset: 0 }],
    json: [], // content heuristics
    html: [], // content heuristics
    csv: [], // content heuristics
    txt: [], // content heuristics
    jpeg: [{ hex: 'FFD8FF', offset: 0 }],
    png: [{ hex: '89504E47', offset: 0 }],
    webp: [{ hex: '52494646', offset: 0 }],
    gif: [{ hex: '47494638', offset: 0 }],
    mp4: [{ hex: '66747970', offset: 4 }],
};
